import React from 'react';
import { Sparkles } from 'lucide-react';
import { SharkConfig } from '../../../components/SharkAvatarSelector';

interface SharkAccessoriesCardProps {
  currentShark: SharkConfig;
  selectedCostume: string;
  onSelectCostume: (costumeId: string) => void;
}

export function SharkAccessoriesCard({
  currentShark,
  selectedCostume,
  onSelectCostume
}: SharkAccessoriesCardProps) {
  return (
    <div style={{
      border: '1px solid var(--admin-card-border)',
      borderRadius: '0',
      backgroundColor: 'var(--admin-card-bg)',
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    }}>
      <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.05em', color: 'var(--admin-card-subtext)', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: '6px' }}>
        <Sparkles size={12} style={{ color: '#38bdf8' }} /> ACCESSORIES
      </div>

      {/* Grid dynamically setting template columns to fit ALL items in ONE ROW */}
      <div 
        className="shark-accessories-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${currentShark.costumes.length}, 1fr)`,
          gap: '8px',
          width: '100%'
        }}
      >
        {currentShark.costumes.map(c => {
          const isSelected = c.id === selectedCostume;
          return (
            <div
              key={c.id}
              onClick={() => onSelectCostume(c.id)}
              className="shark-accessory-item"
              style={{
                padding: '12px 6px',
                borderRadius: '0',
                border: isSelected ? '1px solid #38bdf8' : '1px solid var(--admin-card-border)',
                backgroundColor: isSelected ? 'rgba(62, 143, 166, 0.08)' : 'rgba(255, 255, 255, 0.015)',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                transition: 'all 0.2s',
                minWidth: 0
              }}
            >
              <div style={{ color: isSelected ? '#38bdf8' : 'var(--admin-card-subtext)' }}>
                {c.icon}
              </div>
              <span 
                className="shark-accessory-text"
                style={{ fontSize: '10px', fontWeight: 600, color: isSelected ? '#38bdf8' : 'var(--admin-card-text)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {c.name}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
